import { deletePros } from "api";
import { Error } from "utils/Response";
import { GetPros } from "../GetPros/action";
import { ActionTypes } from "./types";
import { GetDecisionDetails } from "../GetDecisionDetails/action";
import { GetDescriptionsSummary } from "redux/DecisionMatrix/GetDecisionSummary/action";


export const DeletePros = (Data, id, decisionId, optionId) => async (dispatch) => {
  try {
    dispatch({ type: ActionTypes.LOADING });
    const { data, status } = await deletePros(Data);
    dispatch({
      type: ActionTypes.SUCCESS,
      payload: data,
    });
    if (status === 204) {
      dispatch(GetPros(id));
      dispatch(GetDecisionDetails(decisionId, false));
      if (optionId) {
        dispatch(GetDescriptionsSummary(optionId));
      }
    }
  } catch (error) {
    Error(error?.response?.data?.error);
    dispatch({
      type: ActionTypes.ERROR,
      payload: error,
    });
  }
};
